import {Component, input} from '@angular/core';

@Component({
  selector: 'app-transport-icon',
  styles: `
    :host {
      display: inline-block;
      line-height: 0;
    }
  `,
  template: `
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      [attr.width]="width()" 
      [attr.height]="height()" 
      viewBox="0 0 24 24" 
      [attr.fill]="color()">
      <path d="M6.5 0C2.916 0 0 2.916 0 6.5S2.916 13 6.5 13 13 10.084 13 6.5 10.084 0 6.5 0zm.69 10.29c-.04.09-.09.17-.16.24s-.15.13-.24.16a.717.717 0 0 1-.58 0 .75.75 0 1 1 .98-.4zm.788-3.523c-.273.199-.728.626-.728 1.253v.23a.75.75 0 0 1-1.5 0v-.23c0-.941.489-1.839 1.341-2.462A1.002 1.002 0 0 0 6.5 3.75c-.551 0-1 .449-1 1a.75.75 0 0 1-1.5 0c0-1.378 1.122-2.5 2.5-2.5S9 3.372 9 4.75c0 .793-.382 1.547-1.022 2.017zM7.5 19a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5zM19.5 19a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5z"/>
      <path d="M15 10.75v10.5c0 .41-.34.75-.75.75h-3.3c.02-.16.05-.33.05-.5 0-1.93-1.57-3.5-3.5-3.5S4 19.57 4 21.5c0 .17.03.34.05.5h-1.3c-.41 0-.75-.34-.75-.75v-7.54A8.42 8.42 0 0 0 6.5 15a8.49 8.49 0 0 0 7.74-5h.01c.41 0 .75.34.75.75zM19.25 13.55h-2.5a.75.75 0 0 0-.75.75v6.95c0 .03.013.055.017.083A3.495 3.495 0 0 1 19.5 18c1.93 0 3.5 1.57 3.5 3.5 0 .171-.027.335-.051.5h.301a.75.75 0 0 0 .75-.75V18.3a4.756 4.756 0 0 0-4.75-4.75z"/>
    </svg>
  `,
  standalone: true
})

export class TransportIconComponent {
  readonly width = input<string>('24px');
  readonly height = input<string>('24px');
  readonly color = input<string>('white');
}
